import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ViewAreaComponent } from './components/view-area/view-area.component';
import { ViewDetailComponent } from './components/view-detail/view-detail.component';
import { UserFeedbackComponent } from './components/view-detail/user-feedback/user-feedback.component';
import { LoginComponent } from './components/login/login.component';
import { ExtractComponent } from './components/extract/extract.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';

const routes: Routes = [
  { path: 'view-area', component: ViewAreaComponent },
  { path: 'area-detail/:id', component: ViewDetailComponent },
  { path: 'area-detail/feedback/:id', component: UserFeedbackComponent },
  { path: 'login', component: LoginComponent },
  { path: 'admin', component: ExtractComponent },
  { path: '', redirectTo: '/view-area', pathMatch: 'full' },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
